<div class="portal--header portal--header__progress">
    <h1 class="heading">Multi-device management submit</h1>
</div>
<div class="portal--main">
    <div class="module-wrapper">
        <div class="dash-grid">
            <div class="dash-grid--item full-width module drop-shadow bottom">
                <div class="dashboard--module-header">
                    <h2 class="subheading-md">Interaction created</h2>
                </div>
                <div class="module--main">
                    <div class="text-center u-spacing--medium">
                        <p class="md">
                            Thank you, your interaction has been created.
                        </p>
                        <p class="md">
                        When the interaction is scheduled, processing the interactions may take some time, depending on the type of interaction requested, number of devices and device connection status.</p>
                        <p class="md">
                        You can monitor these in the <a (click)="navigateToDeviceInteraction()" style="cursor:pointer" class="text-link focus-element"><span class="focus--content"><strong>device interactions</strong></span></a> section of the site.</p>
                        <div class="btn-group btn-group__stacked-sm text-center u-spacing--medium">
                        <button type="button" (click)="newInteraction()" class="std-btn focus-element"><span class="focus--content" tabindex="-1">Create new interaction</span></button>
                        <button class="std-btn focus-element" (click)="navigateToDeviceInteraction(true)"><span class="focus--content" tabindex="-1">View interactions</span></button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
